import React, { useContext } from 'react'

import { FormContext } from '../../FormContext';
import InputAddRemove from './InputAddRemove';
import { isFieldSigned ,determineIsDisabled} from './utils.js';

const Select = ({ field_multiple_index, field_multiple, field_disabled_approver, field_multiple_primary, field_column, field_id, field_multiple_id, field_label, field_disabled, field_value = "", field_options, options, field_mandatory,field_multiple_type }) => {
  // const options = JSON.parse(field_options)
  // //console.log('options', options)
  const { handleChangeInput, formChatPerson, formStatus, formPageType, formUserLock,formApprovalIndex,formMultipleType ,formOfficers} = useContext(FormContext);



  if (!field_options) {
    field_options = options
  }

  // formPageType === 'user' && !field_value.startsWith('#sign')
  //       ? true:field_disabled || (formStatus=== 'Submitted' && field_multiple_id==='mapprover')
  // let isSigned = field_id.startsWith("sign_");




let isSigned = isFieldSigned(field_id,formMultipleType,formChatPerson,formOfficers,field_multiple_type);
  // const isDisabled = (formUserLock && formPageType== 'user') ? true:formPageType === 'user'
  //   ? (field_multiple_id === "mapprover"
  //     ? (field_id.startsWith('user_approver_') || field_id.startsWith('user_action_')) && parseInt(field_id.slice(-1)) < formApprovalIndex
  //     : true)
  //   : field_disabled_approver === '1' || field_disabled || isSigned || (formStatus === 'Submitted' && (field_multiple_id === 'mapprover' || field_id.startsWith('user_approver_')));

  // let isDisabled;
  // if (formUserLock && formPageType === 'user') {
  //   isDisabled = true;
  // } else if (formPageType === 'user') {
  //   if (field_multiple_id === 'mapprover') {
  //     isDisabled = isSigned||(
  //       (field_id.startsWith('user_approver_') ||
  //         field_id.startsWith('user_action_')) &&
  //       parseInt(field_id.slice(-1)) < formApprovalIndex);
  //   } else {
  //     isDisabled = true;
  //   }
  // } else {
  //   isDisabled =
  //     field_disabled_approver === '1' ||
  //     field_disabled ||
  //     isSigned ||
  //     (formStatus === 'Submitted' &&
  //       (field_multiple_id === 'mapprover' ||
  //         field_id.startsWith('user_approver_')));
  // }
  const isDisabled = determineIsDisabled(
    formUserLock,
    formPageType,
    field_multiple_id,
    isSigned,
    field_id,
    formApprovalIndex,
    field_disabled_approver,
    field_disabled,
    formStatus
  );

  //console.log('field_options', field_options) disabled={field_disabled || (formStatus=== 'Submitted' && field_multiple_id==='mapprover')
  return (
    <div className={`form-group ${field_column ? field_column : 'col-sm-6'}`}>
      <label>{field_label}<font color="red">{field_mandatory === 'yes' ? ' *' : ''}</font></label>
      <select className="form-control form-input force-info" id="hsuhk_identity" name="field_value" onChange={event => handleChangeInput(field_id, event)}
        
        disabled={isDisabled}>
        <option value="">- Select  -</option>
        {field_options.length > 0 && field_options.map((option, i) => <option key={i} selected={field_value.trim() === option.option_label.trim()} value={JSON.stringify(option)}>{option.option_label} </option>)}

      </select>

      {/* {(formPageType === 'user' && field_multiple_primary == "yes" ? true : field_multiple_primary == "yes" && formStatus !== 'Submitted') && <div className='mt-3 text-right'>

        <u className="text-success mr-3" onClick={() => handleAddField(field_id)}>Add </u>
        <u className="text-danger" onClick={() => handleRemoveLastField(field_id)}>Remove </u>
      </div>} */}
      
      {!formUserLock && <InputAddRemove field_id={field_id} field_multiple_id={field_multiple_id} field_multiple_type={field_multiple_type}/>}

    </div>
  )
}

export default Select
